import { Component, Input } from '@angular/core';
import {
  MatTooltip,
  MatTooltipModule,
  TooltipPosition,
} from '@angular/material/tooltip';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { saxInfoCircleOutline } from '@ng-icons/iconsax/outline';

@Component({
  selector: 'app-icon-tool-tip',
  standalone: true,
  imports: [MatTooltip, NgIcon, MatTooltipModule],
  providers: [
    provideIcons({
      saxInfoCircleOutline,
    }),
  ],
  templateUrl: './icon-tool-tip.component.html',
  styleUrl: './icon-tool-tip.component.scss',
})
export class IconToolTipComponent {
  @Input({ required: true }) matTooltipInfo!: string;
  @Input({ required: false }) matTooltipPositionInfo: TooltipPosition = 'above';
}
